import MasterTab from 'src/components/Layouts/MasterTab.vue';
import Presentism from "src/views/Pages/Dashboard/Grow/Reports/Presentism/Presentism.vue";
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';

const PresentismRoutes = {
  path: 'grow',
  name: 'grow.grow',
  component: MasterTab,
  props: { reference: 'growTabs' },
  children: [
    {
      path: 'presentism',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'grow.presentism',
          component: Presentism,
          meta: {
            prefix_permission: 'grow_presentism',
          },
        },
      ],
    },
  ],
};

export default PresentismRoutes;